import React, { FC } from "react";

import { Text } from "@epignosis_llc/gnosis";
import { useResponsive } from "ahooks";

import {
  StyledFallbackErrorScreenContainer,
  StyledFallbackErrorScreenText,
} from "@layouts/DashboardLayout/components/FallbackErrorScreen/styles";

import { useApplyTranslations } from "@hooks";

import { images } from "@constants/assets";

const FallbackErrorScreen: FC = () => {
  const { t } = useApplyTranslations();
  const { md } = useResponsive();

  return (
    <section css={StyledFallbackErrorScreenContainer(md)}>
      <img src={images.errors.errorBoundaryImg} alt={t(`general.somethingWentWrong`)} />
      <div css={StyledFallbackErrorScreenText}>
        <Text as="p" fontSize="lg" weight="700">
          {t(`errors.general.somethingWentWrong`)}
        </Text>
        <Text as="p" fontSize="md">
          {t(`skills.mySkills.assessment.pleaseTryAgainLater`)}
        </Text>
      </div>
    </section>
  );
};

export default FallbackErrorScreen;
